import { Head, usePage } from "@inertiajs/react";
import AuthShell from "@/components/auth/AuthShell";
import CheckEmailCard from "@/components/auth/CheckEmailCard";

export default function CheckEmail({ email, link_expires_in, mail_preview_path }) {
  const { routes } = usePage().props;

  return (
    <AuthShell helpHref={routes.help}>
      <Head title="Check your email" />
      <CheckEmailCard
        description={
          <>
            If there's an account for <span className="font-medium text-foreground">{email}</span>, we've sent it a sign-in link.
            The link works for {link_expires_in}.
          </>
        }
        tips={["Check your spam folder.", "Make sure the address above is right.", "Wait a minute and try again."]}
        retry={{ href: routes.sign_in, label: "Use a different email" }}
        mailPreviewPath={mail_preview_path}
      />
    </AuthShell>
  );
}
